import { callMBankBridge } from 'shared/lib/mbank-bridge'

interface ShareTextParams {
  url: string
  title?: string
  onCopied?: () => void
}

const getShareText = ({ title, url }: ShareTextParams) =>
  title ? `${title}\n${url}` : url

const openShareUrl = (url: string) => {
  window.open(url, '_blank')
}

const copyShareUrl = ({ url, onCopied }: ShareTextParams) => {
  if (!navigator.clipboard) {
    openShareUrl(url)

    return
  }

  navigator.clipboard
    .writeText(url)
    .then(() => {
      onCopied?.()
    })
    .catch(() => {
      openShareUrl(url)
    })
}

const fallbackShare = (params: ShareTextParams) => {
  if (!navigator.share) {
    copyShareUrl(params)

    return
  }

  navigator
    .share({
      title: params.title,
      url: params.url,
    })
    .catch(() => {
      copyShareUrl(params)
    })
}

export const shareText = (params: ShareTextParams) => {
  void callMBankBridge('share.text', {
    text: getShareText(params),
  }).then((response) => {
    if (response.ok) return

    fallbackShare(params)
  })
}
